<template>
  <button
    :disabled="loading"
    type="button"
    :class="[
      'sqf-item-container',
      active ? 'active' : '',
    ]"
    :style="{
      backgroundColor: active ? activeColor : '',
    }"
    @click="toggle(filterItem)"
  >
    <span class="grid-column ai-c jc-b">
      <img
        :src="getImage()"
        :class="['img-size-20', active && activeTextColor ? 'dark-image' : '']"
        alt="icon"
      >
      <span :class="['grid-column ai-c gap-5 sac__font-18 semi-bold', activeTextColor && active ? activeTextColor : 'f-white']">
        <span class="grid-row ji-e">
          <span>{{ label }}</span>
          <span v-if="subLabel" class="sac__font-10 med n40">{{ subLabel}}</span>
        </span>
        <span
          v-if="!loading"
          class="sqf-count"
        >
          {{ count }}
        </span>
        <img
          v-else
          src="@shared/assets/img/general/loading-mini-white.svg"
          alt="loading"
        >
      </span>
    </span>
  </button>
</template>

<script>

export default {
  name: 'QuickFilterItem',
  components: {},
  props: {
    label: String,
    subLabel: String,
    count: Number,
    activeColor: String,
    activeTextColor: String,
    imageSrc: String,
    filterItem: String,
    toggle: Function,
    active: Boolean,
    loading: Boolean,
  },
  methods: {
    getImage() {
      return require(`@shared/assets/img/leads/${this.imageSrc}.svg`);
    },
  },
};
</script>

<style lang="scss">
.sqf-item-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  justify-content: center;
  background: $N95;
  border-radius: 6px;
  cursor: pointer;
  height: 90px;
  &:not(:last-child) {
    margin-right: 16px;
  }
  &:hover {
    opacity: 0.8;
  }
  &.active {
    opacity: 1;
  }
  .sqf-count {
    background-color: rgba(255, 255, 255, 0.20);
    padding: 4px 8px;
    border-radius: 6px;
    font-weight: 700;
    min-width: 34px;
    text-align: center;
  }
  .dark-image {
    filter: brightness(0%);
  }
}
</style>
